import { render, staticRenderFns } from "./CommonSelectPerson.vue?vue&type=template&id=46721bb8&scoped=true"
import script from "./CommonSelectPerson.vue?vue&type=script&lang=js"
export * from "./CommonSelectPerson.vue?vue&type=script&lang=js"
import style0 from "./CommonSelectPerson.vue?vue&type=style&index=0&id=46721bb8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46721bb8",
  null
  
)

export default component.exports